import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TitleLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const SubtitleLabel = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const Root = styled.div`
  width: 100%;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '132px',
        borderRadius: '8px',
      },
    },
  ],
})``;
